module.exports = __webpack_public_path__ + "media/yu-fish.f0c53f5f.mp3";